import { getGroupCategoriesStore } from '../modules/groupCategories';
import { GroupsStore } from './Groups';

export const GroupCategoriesStore = getGroupCategoriesStore(GroupsStore.getInstance());
